<template>
    <div>
        <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
            <el-form-item label="媒体：" prop="plat_name" v-show="editableFieldNames.includes('plat_name')||!isEdit">
                <el-input v-model.trim="formItem.plat_name" placeholder="请输入媒体名称" style="width: 360px;" maxlength="10"></el-input>
                <span class="ml10 font12px text-color-gray">{{formItem.plat_name.length}}/10</span>
            </el-form-item>
            <el-form-item label="对接状态：" prop="docking_status" v-show="editableFieldNames.includes('docking_status')||!isEdit">
                <el-radio-group v-model="formItem.docking_status">
                    <el-radio label="0">未对接</el-radio>
                    <el-radio label="1">已对接</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="停用状态：" prop="status" v-show="editableFieldNames.includes('status')||!isEdit">
                <el-radio-group v-model="formItem.status">
                    <el-radio label="0">停用</el-radio>
                    <el-radio label="1">启用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注：" prop="note" v-show="editableFieldNames.includes('note')||!isEdit">
                <el-input type="textarea" :rows="1" v-model.trim="formItem.note" placeholder="请输入" style="width: 360px;" maxlength="50"></el-input>
                <span class="ml10 font12px text-color-gray">{{formItem.note.length}}/50</span>
            </el-form-item>
            <el-form-item v-if="editableFieldNames.length<=0&&isEdit">
                <p class="text-color-gray">无可编辑的字段权限</p>
            </el-form-item>
        </el-form>
        <div class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="editableFieldNames.length<=0&&isEdit" class="action-btn ml20" v-matomo="{behaviorCategory: '标签管理(媒体)',name: isEdit?'列表(编辑-提交)':'添加媒体(提交)' }">提交</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    import { validEmoji, validHtml } from '@/utils/validate';
    import API from '@/api/baseInfo/tag.js';

    export default {
        name: "AddPlatModal",
        props:{
            data:{
                type: Object,
                required: true
            },
            cbs:{
                type:Object,
            },
            editableFields:Array,
        },
        data(){
            const validContent = (rule, value, callback) => {
                // const regex = /[<>\/?{}"|\\';#¥%^&*+=]/;
                if (validHtml(value) || validEmoji(value)||value.includes(' ')) {
                    callback(new Error('不可输入空格、表情、HTML字符'))
                }else {
                    callback()
                }
            };
            return {
                formItem:{
                    plat_name:'',
                    docking_status:'',
                    status:'',
                    note:'',
                },
                rules:{
                    // plat_name:[
                    //     { required: true, message: '请输入媒体名称', trigger: 'blur' },
                    //     { validator: validContent, trigger: 'blur' },
                    // ],
                    // docking_status:[
                    //     { required: true, message: '请选择对接状态', trigger: 'change' },
                    // ],
                    // status:[
                    //     { required: true, message: '请选择停用状态', trigger: 'change' },
                    // ],
                    note:[
                        { max: 500, message: '最多可输入500字', trigger: 'blur' },
                    ],
                },
                submitLoading:false,
            }
        },
        computed:{
            isEdit(){
                return this.data.plat_id;
            },
            editableFieldNames(){
                let list = this.editableFields||[];
                return list.map(item=>item.name);
            },
        },
        mounted(){
            if(this.isEdit){
                this.setData();
            }else{
                this.formItem.docking_status = '0';
                this.formItem.status = '0';
            }
            this.setRules();
            this.$nextTick(()=>{
                this.$refs.form.clearValidate();
            })
        },
        methods:{
            setData(){
                this.formItem.plat_name = this.data.plat_name;
                this.formItem.docking_status = this.data.docking_status=='已对接'?'1':'0';
                this.formItem.status = this.data.status=='启用'?'1':'0';
                this.formItem.note = this.data.note||'';
            },
            setRules(){
                if(this.editableFieldNames.includes('plat_name')||!this.isEdit){
                    this.$set(this.rules,'plat_name',[
                        { required: true, message: '请输入媒体名称', trigger: 'blur' },
                        { validator: this.validContent, trigger: 'blur' },
                    ]);
                }
                if(this.editableFieldNames.includes('docking_status')||!this.isEdit){
                    this.$set(this.rules,'docking_status',[
                        { required: true, message: '请选择对接状态', trigger: 'change' },
                    ]);
                }
                if(this.editableFieldNames.includes('status')||!this.isEdit){
                    this.$set(this.rules,'status',[
                        { required: true, message: '请选择停用状态', trigger: 'change' },
                    ]);
                }
            },
            validContent(rule, value, callback){
                // const regex = /[<>\/?{}"|\\';#¥%^&*+=]/;
                if (validHtml(value) || validEmoji(value)||value.includes(' ')) {
                    callback(new Error('不可输入空格、表情、HTML字符'))
                }else {
                    callback()
                }
            },
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        let apiType = 'addPlat';
                        let reqData = {
                            // plat_name:this.formItem.plat_name,
                            // docking_status:this.formItem.docking_status,
                            // status:this.formItem.status,
                            // note:this.formItem.note,
                        };

                        ['plat_name','docking_status','status','note'].forEach(item=>{
                            if(this.editableFieldNames.includes(item)||!this.isEdit){
                                reqData[item] = this.formItem[item];
                            }
                        });

                        if(this.isEdit){
                            apiType = 'editPlat';
                            reqData.plat_id = [this.data.plat_id];
                        }

                        this.submitLoading = true;
                        API[apiType](reqData).then(res=>{
                            this.submitLoading = false;
                            console.log('res',res);
                            this.$message.success(res.info||'操作成功');
                            this.cbs.onSubmit();
                            this.$emit('close');
                        },err=>{
                            this.submitLoading = false;
                            console.log('err',err);
                            this.$message.error(err.info||'请求异常');
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        }
    }
</script>

<style scoped>

</style>
